import React from 'react';
import theme from '../config/theme';

interface PageContainerProps {
  children: React.ReactNode;
  padding?: string;
}

const PageContainer: React.FC<PageContainerProps> = ({ children, padding = 'py-8' }) => (
  <div className="min-h-screen" style={{ backgroundColor: theme.colors.background }}>
    <div className={`container mx-auto px-4 ${padding}`}>
      {children}
    </div>
  </div>
);

export default PageContainer;
